import isCommentSection from './isCommentSection';
import isGridSection from './isGridSection';
import isMetricSection from './isMetricSection';
import isPerformanceSection from './isPerformanceSection';
import isTargetProgressSection from './isTargetProgressSection';
import isPropertiesSection from './isPropertiesSection';
import isRelatedDocumentsSection from './isRelatedDocumentsSection';
import isRelatedMetricDocumentsSection from './isRelatedMetricDocumentsSection';
import isBonusRewardSection from './isBonusRewardSection';
import isBonusTotalRewardSection from './isBonusTotalRewardSection';
import isBonusEligibilitySection from './isBonusEligibilitySection';
import isRecognitionPaymentsSection from './isRecognitionPaymentsSection';

const sectionTypeCheckers = {
  isPerformanceSection,
  isTargetProgressSection,
  isMetricSection,
  isPropertiesSection,
  isGridSection,
  isCommentSection,
  isRelatedDocumentsSection,
  isRelatedMetricDocumentsSection,
  isBonusRewardSection,
  isBonusTotalRewardSection,
  isBonusEligibilitySection,
  isRecognitionPaymentsSection,
};

export default sectionTypeCheckers;
